<template>
    <div class="tabs__content" v-if="active == name">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'TabsContentComponent',
    props: {
        name: String,
        active: String
    }
}
</script>



// WEBPACK FOOTER //
// TabsContent.vue?52de9a0c